import $ from 'jquery'
import prop from 'vue-strict-prop'
import { component } from 'vue-tsx-support'

export default component({
	name: 'DropdownMenu',
	props: {
		value: prop(String).default(''),
	},
	watch: {
		value(newValue: string, oldValue: string): void {
			if (newValue === oldValue) {
				return
			}

			$(this.$el).dropdown('set selected', this.value)
		},
	},
	mounted() {
		$(this.$el).dropdown({
			onChange: (value, text, $selectedItem) => this.$emit('input', value),
		})

		$(this.$el).dropdown('set selected', this.value)
	},
	methods: {
		toggle(): void {
			$(this.$el).dropdown('toggle')
		},
	},
	render() {
		return (
			<div class="ui dropdown">
				{this.$slots.default}
			</div>
		)
	},
})
